module.exports = __webpack_public_path__ + "img/programs_immersive.9cd3d413.png";